module.exports = __webpack_public_path__ + "static/media/create-new-icon@3x.759615bb.jpg";